<template>
  <div>
    <label class="formulate-input-label" style="margin:0;" for="valueGroup">
      {{label}}
      <span v-if="required" style="color: red; margin-left: 2px;">*</span>
    </label>
    <div id="valueGroup" style="display: flex; justify-content: space-between; gap: .8rem; padding-top: 8px;">
      <NxInput
      name="dateInicial"
      type="date"
      placeholder="De:"
      :value="localInitialValue"
      @update:value="handleInitialValueUpdate"
      :max="getCurrentDate()"
      :class="{ 'input-error': showError && !localInitialValue }"
    ></NxInput>
      <NxInput
      name="dateFinal"
      type="date"
      placeholder="Até:"
      :value="localFinalValue"
      @update:value="handleFinalValueUpdate"
      :max="getCurrentDate()"
      :class="{ 'input-error': showError && !localFinalValue }"
    ></NxInput>
    </div>
    <div v-if="showError && (!localInitialValue || !localFinalValue)" class="error-message">
      Os campos de período são obrigatórios
    </div>
  </div>
</template>
<script>
import { useReactiveModelMixin } from '../../mixins'

export default {
  name: 'NxInputDateRange',
  mixins: [useReactiveModelMixin('InitialValue'), useReactiveModelMixin('FinalValue')],
  props: {
    label: {
      required: true,
      type: String,
      default: null
    },
    required: {
      type: Boolean,
      required: false,
      default: false
    },
    showError: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  methods: {
    // NEEDS TO MAP REPLACE - FOR / BEFORE SUBMITNG
    handleInitialValueUpdate (val) {
      this.localInitialValue = val
    },
    handleFinalValueUpdate (val) {
      this.localFinalValue = val
    },
    getCurrentDate () {
      let date = new Date()
      let day = String(date.getDate()).padStart(2, '0')
      let month = String(date.getMonth() + 1).padStart(2, '0') // January is 0!
      let year = date.getFullYear()

      let currentDate = year + '-' + month + '-' + day

      return currentDate
    }
  }
}
</script>
<style lang="scss" scoped>
#valueGroup{
  .formulate-input{
    width: 100%;
  }
}

.input-error ::v-deep .formulate-input-element input {
  border-color: #dc3545 !important;
  border-width: 2px;
}

.error-message {
  color: #dc3545;
  font-size: 0.875rem;
  margin-top: 0.25rem;
  padding-left: 0.25rem;
}
</style>



// WEBPACK FOOTER //
// src/components/nexum/components/custom-inputs/NxInputDateRange.vue